import { attributeDefinitionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteAttributeDefinition = {
  name: "deleteAttributeDefinition" as const,
  input: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),

  output: z.object({ success: z.boolean() }),
};
